import type { EntityStatus } from '@ms/yammer-data-support';
import { getStatusForId } from '@ms/yammer-data-support';

import type { User, YammerState } from '../../state/types';
import { createFindById } from '../findById';
import type { FindById } from '../findById';

/**
 * @deprecated PERFORMANCE This selects an entity object, which will return a new instance and force re-renders
 * when changed. This should be replaced by a `getUserInformationBarrierSettingsField` selector, or consumers
 * should call the more specific selectors in this file.
 */
export const findById: FindById<'userInformationBarrierSettings'> = createFindById('userInformationBarrierSettings');

type GetUserInformationBarrierSettingsStatus = (state: YammerState, userId: User['id']) => EntityStatus;
export const getUserInformationBarrierSettingsStatus: GetUserInformationBarrierSettingsStatus = (state, userId) =>
  getStatusForId(state.userInformationBarrierSettings, userId);

type HasInformationBarrierRestrictions = (state: YammerState, userId: User['id']) => boolean;
export const hasInformationBarrierRestrictions: HasInformationBarrierRestrictions = (state, userId) =>
  findById(state, userId)?.hasInformationBarrierRestrictions ?? false;
